export function getYakThemeContext() {
  return {};
}
